import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getOvertimePolicyById } from '../../services/timesheetService';
import { useAuth } from '../../context/AuthContext';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import PolicyRulesPanel from '../../components/ui/PolicyRulesPanel';

// Fazla mesai politikasının atama kuralları (AKM POC §6.2). Politikanın kendisi listedeki çekmecede
// düzenlenir; bu sayfa yalnız "kime, hangi tarihten itibaren" sorusunu yönetir. Yazma kapısı TA.
//
// Tek kaydırma: sayfa kabı sabit yükseklikte ve taşmaz; kayan yalnız kural tablosunun satırlarıdır.
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 8px;
`;

export default function OvertimePolicyDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { canWrite } = useAuth();
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    // api.js GET'te reddetmez: sinyal res.data.status.
    getOvertimePolicyById(id).then((res) => {
      if (res?.data?.status === true) setPolicy(res.data.data);
    });
  }, [id]);

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('overtimePolicy.title'), path: '/overtime-policies' },
          { label: policy?.name || '...' },
        ]} />
      </StickyHeader>

      <Content>
        <PolicyRulesPanel
          kind="overtimePolicy"
          policyId={id}
          title={t('overtimePolicy.assignmentRules')}
          canWrite={canWrite('TA')}
        />
      </Content>
    </PageContainer>
  );
}
